import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';

export default class ExportPaymentSearchParams extends SearchParamsBase {
  initialize() {
    const urlParams = new URLSearchParams(window.location.search);

    this.ExportPaymentId = '';
    this.ExportId = urlParams.get('id');
    this.PaymentMethod = '';
    this.Status = '';
    this.EvaluatorName = '';
    this.EvaluatorEmail = '';
    this.EvaluatorId = '';
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static selectOptionsForPaymentMethod = [
    { label: 'Choose one...', value: '', disabled: true },
    { label: 'International', value: 'I', disabled: false },
    { label: 'Direct Deposit', value: 'D', disabled: false },
    { label: 'Check', value: 'C', disabled: false },
  ];

  static selectOptionsForStatus = [
    { label: 'Choose one...', value: '', disabled: true },
    { label: 'Created', value: '1', disabled: false },
    { label: 'Approved', value: '2', disabled: false },
    { label: 'Paid', value: '3', disabled: false },
    { label: 'Pending Recon', value: '4', disabled: false },
    { label: 'Reconciled', value: '5', disabled: false },
    { label: 'Void', value: '6', disabled: false },
    { label: 'Suppressed', value: '7', disabled: false },
    { label: 'Pending Approval', value: '8', disabled: false },
    { label: 'Info Required', value: '9', disabled: false },
    { label: 'Closed', value: '10', disabled: false },
    { label: 'Pending Approval by Supervisor', value: '11', disabled: false },
    { label: 'Info Required by Supervisor', value: '12', disabled: false },
    { label: 'To be sent to Tipalti', value: '13', disabled: false },
    { label: 'Sent to Tipalti', value: '14', disabled: false },
    { label: 'Pending Tipalti', value: '15', disabled: false },
    { label: 'Deferred Or Error at Tipalti', value: '16', disabled: false },
    { label: 'Paid Outside of System', value: '17', disabled: false },
  ];

  static fieldsInSearchBox = [
    { fieldName: 'ExportPaymentId', label: 'Export Payment ID', className: 'col-6', type: InputTypesEnum.Text },
    { fieldName: 'ExportId', label: 'Export ID', className: 'col-6', type: InputTypesEnum.Text, hide: true },
    {
      fieldName: 'PaymentMethod',
      label: 'Payment Method',
      className: 'col-6',
      type: InputTypesEnum.Select,
      options: ExportPaymentSearchParams.selectOptionsForPaymentMethod,
    },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-6',
      type: InputTypesEnum.Select,
      options: ExportPaymentSearchParams.selectOptionsForStatus,
    },
    { fieldName: 'EvaluatorName', label: 'Evaluator Name', className: 'col-6', type: InputTypesEnum.Text },
    { fieldName: 'EvaluatorEmail', label: 'Evaluator Email', className: 'col-6', type: InputTypesEnum.Text },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'ExportPaymentSearchParams';
  static maxWidth = 1000;
  static urlMappedValues = ['ExportId'];

  //---------------------------
}
